import apiClient from './api';


async function unblockEvent(eventId) {
  try {
    const response = await apiClient.post('/unblock-event/' + eventId, {}); // Replace with your endpoint
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return { success: false, message: "No response received", details: error.request };
    } else {
      // Something happened in setting up the request that triggered an Error
      return { success: false, message: "Request setup error", details: error.message };
    }
  }
}

async function getEvent(eventId) {
  try {
    const response = await apiClient.get('/get-Event/' + eventId, {}); // Replace with your endpoint
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return { success: false, message: "No response received", details: error.request };
    } else {
      // Something happened in setting up the request that triggered an Error
      return { success: false, message: "Request setup error", details: error.message };
    }
  }
}


async function fetchEvent(id) {
  try {
    const response = await apiClient.get(`/event/${id}`);
    return response.data; 
  } catch (error) {
    throw error;
  }
}


async function deleteEvent(eventId) {
  try {
    const response = await apiClient.post('/delete-event/' + eventId, {}); // Replace with your endpoint
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return { success: false, message: "No response received", details: error.request };
    } else {
      // Something happened in setting up the request that triggered an Error
      return { success: false, message: "Request setup error", details: error.message };
    }
  }
}

async function blockEvent(EventId) {
  try {
    const response = await apiClient.post('/block-event/' + EventId, {}); // Replace with your endpoint
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return { success: false, message: "No response received", details: error.request };
    } else {
      // Something happened in setting up the request that triggered an Error
      return { success: false, message: "Request setup error", details: error.message };
    }
  }
}

async function getEventCategories() {
  try {
    const response = await apiClient.get('/get-event-categories'); // Replace with your endpoint
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return { success: false, message: "No response received", details: error.request };
    } else {
      // Something happened in setting up the request that triggered an Error
      return { success: false, message: "Request setup error", details: error.message };
    }
  }
}

async function getSpecialCategories() {
  try {
    const response = await apiClient.get('/get-special-categories'); // Replace with your endpoint
    return response;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      return error.response;
    } else if (error.request) {
      // The request was made but no response was received
      return { success: false, message: "No response received", details: error.request };
    } else {
      // Something happened in setting up the request that triggered an Error
      return { success: false, message: "Request setup error", details: error.message };
    }
  }
}

async function fetchAll(data) {
    try {
      const response = await apiClient.get('/get-all-events', data); // Replace with your endpoint
      return response;
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        return error.response;
      } else if (error.request) {
        // The request was made but no response was received
        return { success: false, message: "No response received", details: error.request };
      } else {
        // Something happened in setting up the request that triggered an Error
        return { success: false, message: "Request setup error", details: error.message };
      }
    }
  }
  async function fetchAllAdmin(data) {
    try {
      const response = await apiClient.get('/get-all-events-admin', data); // Replace with your endpoint
      return response;
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        return error.response;
      } else if (error.request) {
        // The request was made but no response was received
        return { success: false, message: "No response received", details: error.request };
      } else {
        // Something happened in setting up the request that triggered an Error
        return { success: false, message: "Request setup error", details: error.message };
      }
    }
  }

  async function createUpdateEvent(id=null, data) {
    try {
      if(id){
        data.id = id;
      }
      const response = await apiClient.post('/create-update-event', data); // Replace with your endpoint
      return response;
    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        return error.response;
      } else if (error.request) {
        // The request was made but no response was received
        return { success: false, message: "No response received", details: error.request };
      } else {
        // Something happened in setting up the request that triggered an Error
        return { success: false, message: "Request setup error", details: error.message };
      }
    }
  }

  async function filesUpload(file, eventData, field = 'event_img') {
    try {
      const formData = new FormData();
      formData.append(field, file);
      formData.append('event_id', eventData.value.id);

      const response = await apiClient.post('/upload-event-image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response;
    } catch (error) {
      return { data: { success: false, message: error.message || 'Upload failed' } };
    }
  }



  async function fetchFilteredEvents(filters) {
    try {
      const response = await apiClient.post('/filtered-events', filters);
      return response;
    } catch (error) {
      return { data: { success: false, data: [], pagination: [], message: error.message || 'Fetch failed' } };
    }
  }

export { getEventCategories, fetchAllAdmin, fetchAll, blockEvent, unblockEvent, deleteEvent, getEvent, createUpdateEvent, getSpecialCategories, filesUpload, fetchFilteredEvents, fetchEvent}
